import { type GetHookResponse } from '../../hooks'
import { taskSnapshotManagersKey } from '../../keys'
import { useTantalimQuery } from '../../query'
import {
  DAY,
  type DecoratedUserSnapshotManager,
  HOUR,
  type SnapshotManagersInput,
  type SnapshotManagersSuccess,
} from '@terros/common'

export function useSnapshotManagers(
  input: SnapshotManagersInput = {}
): GetHookResponse<DecoratedUserSnapshotManager[]> {
  return useTantalimQuery<SnapshotManagersInput, SnapshotManagersSuccess, DecoratedUserSnapshotManager[]>({
    url: '/task/snapshot/managers',
    queryKey: taskSnapshotManagersKey(),
    input,
    convertResponse: (data) => data.managers,
    options: {
      gcTime: DAY,
      staleTime: HOUR,
    },
  })
}
